<template>
    <img v-if="avatar" class="cursor-pointer" :src="avatar" alt="profile image" />
    <span v-else class="cursor-pointer">
        <span v-if="name !== undefined" class="font-medium leading-none text-white">
            {{ name.substring(0, 1) }}
        </span>
    </span>
</template>

<script>
export default {
    name: 'org-avatar',
    props: {
        org: Object,
    },
    computed: {
        avatar() {
            return this.org.avatar;
        },
        name() {
            return this.org.name;
        },
    },
};
</script>
